import HeaderLine from "../font/headerline";
import Header from "../font/header1";
import Header2 from "../font/header2";
import Card from "../layout/card";
import Threebox from "../layout/threebox";
import H4 from "../font/H4";

const steps = [
    {
        number: '1',
        title: 'Request quotes',
        description: "Tell us what you need done and we'll match you with vetted local pros ready to quote your job.",
    },
    {
        number: '2',
        title: 'Compare & hire',
        description: 'Review quotes side by side, check pro ratings, and hire the one that fits your budget and timeline.',
    },
    {
        number: '3',
        title: 'Track the job',
        description: 'Follow appointment scheduling and job status right from your dashboard, from first quote to completed work.',
    },
];

const Marketplace = () => {
    return (
        <div className='flex flex-col justify-center pt-16 lg:pt-24 lg:p-10'>
            <div className='flex flex-row'>
                <HeaderLine />
                <div className='flex flex-col place-items-center flex-1 lg:flex-none w-full lg:w-auto px-4'>
                    <Header>Find & Hire Trusted Pros</Header>
                </div>
                <HeaderLine />
            </div>
            <Header2>Request quotes, compare pros, and hire — all in one place</Header2>
            <Threebox>
                {steps.map((step) => (
                    <Card key={step.number}>
                        <div className="flex rounded-full justify-center items-center bg-lightblue w-16 h-16 text-2xl font-bold text-blue">
                            {step.number}
                        </div>
                        <H4>{step.title}</H4>
                        <p className="text-center">{step.description}</p>
                    </Card>
                ))}
            </Threebox>
        </div>
    )
}

export default Marketplace
